import React from "react";
import PropTypes from "prop-types";
import {
  getAllSetsCounts,
  shouldHaveE1RM,
  hasEqualOutcomes,
  formattedTarget,
} from "../../../../utils/actuals";
import { parameterName } from "../../../../parts/other-exercise/CustomParametersSets";
import SvgIcon from "../../../../parts/SvgIcon";

const {
  PARAMETER_OPTIONS: { FREEFORM, ROUNDS, SETS },
} = require("../../../../constants");

const StatusComponent = ({ total, completed, missed }) => {
  if (completed === 0 && missed === 0) {
    return (
      <div className="status-missed">
        <SvgIcon src="/img/new-icons/info-circle.svg" noFilterOnLight={true} />
      </div>
    );
  }

  if (completed > 0) {
    return (
      <>
        <div className="status-completed">
          <SvgIcon
            src="/img/new-icons/tick-square.svg"
            noFilterOnLight={true}
          />
          {`${completed}/${total}`}
        </div>
        {missed > 0 && (
          <div className="status-missed">
            <SvgIcon
              src="/img/new-icons/info-circle.svg"
              noFilterOnLight={true}
            />
            {missed}
          </div>
        )}
      </>
    );
  }

  return (
    <div className="status-missed">
      <SvgIcon src="/img/new-icons/info-circle.svg" noFilterOnLight={true} />
      {`${missed}/${total}`}
    </div>
  );
};

const ActualResultsHead = (props, { locals }) => {
  const { athlete, query } = locals;
  const { date, view, organizationCoach } = query;
  const {
    exercise,
    exerciseName,
    prefix,
    expanded,
    toggleExpanded,
    intensityMeasure,
    isRiR,
    set,
    targetRM,
    units,
    targetLoad,
    hideVelocitySettings,
  } = props;
  const { parameters, type, primary, secondary } = exercise;

  const showE1RM = shouldHaveE1RM(exercise);
  const showPercentRM = type === "primary" || type === "secondary";
  const { total, completed, missed } = getAllSetsCounts(exercise);
  const equalOutcomes = hasEqualOutcomes(exercise);

  let exerciseHistoryLink = query.athlete
    ? `/athlete-portal/metrics/exercise-history?type=${type}&primary=${primary}`
    : `/dashboard/metrics/exercise-history?type=${type}&primary=${primary}`;

  if (secondary) exerciseHistoryLink += `&secondary=${secondary}`;

  if (athlete) exerciseHistoryLink += `&athlete=${athlete._id}`;

  if (view === "day" && date) exerciseHistoryLink += `&date=${date}&view=day`;

  if (organizationCoach)
    exerciseHistoryLink += `&organizationCoach=${organizationCoach}`;

  return (
    <>
      <div className="name-wrapper justify-between">
        <div className="flex items-center gap-2">
          <span className="calendar-prefix">{prefix}</span>
          <p className="font-semibold">
            {exerciseName.charAt(0).toUpperCase() + exerciseName.slice(1)}
          </p>
        </div>

        <div className="actuals-head-status mobile-hidden">
          <span>Status:</span>
          <StatusComponent
            total={total}
            completed={completed}
            missed={missed}
          />
          {view === "day" && (
            <a
              href={exerciseHistoryLink}
              data-button-type="outline"
              role="button"
            >
              <span>Exercise History</span>
            </a>
          )}
        </div>
      </div>

      <div className="actuals-head">
        <p className="p4 min-w-[250px] mobile-hidden">Targets:</p>

        <div className="actuals-titles">
          <p className="p4">Results</p>
          <p className="p4">#</p>
          {parameters ? (
            Array.from({ length: parameters.length }, (x, i) =>
              [FREEFORM, ROUNDS, SETS].includes(parameters[i]) ? null : (
                <p
                  key={`${i}-${exercise._id}-title`}
                  className="p4 mobile-hidden"
                >
                  {parameterName(parameters[i], isRiR)}
                </p>
              )
            )
          ) : (
            <>
              <p className="p4">Reps</p>
              <p className="p4">{intensityMeasure}</p>
              <p className="p4">Load</p>
            </>
          )}
          {showPercentRM && <p className="p4 mobile-hidden">%1RM</p>}
          {showE1RM && <p className="p4 mobile-hidden">e1RM</p>}
          {showPercentRM && !hideVelocitySettings && (
            <p className="p4mobile-hidden">Vel.</p>
          )}
          {parameters && parameters[0] == FREEFORM && (
            <p className="p4 freeform mobile-hidden"></p>
          )}
          <p className="p4 video">Video</p>
          <p className="p4 description mobile-hidden">Comment</p>
          {equalOutcomes && (
            <p
              className="p4 expand-outcomes mobile-hidden"
              onClick={toggleExpanded}
            >
              {expanded ? "See less" : "Expand"}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

ActualResultsHead.contextTypes = { locals: PropTypes.object };

export default ActualResultsHead;
